import { render, staticRenderFns } from "./MedicineModKei.vue?vue&type=template&id=744d8968"
import script from "./MedicineModKei.vue?vue&type=script&lang=js"
export * from "./MedicineModKei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports